import { Component, OnInit } from '@angular/core';
import { Storage } from '@ionic/storage-angular';
import { ModalController, ToastController } from '@ionic/angular';

@Component({
  selector: 'app-widget-cronograma',
  templateUrl: './widget-cronograma.component.html',
  styleUrls: ['./widget-cronograma.component.scss'],
  standalone: false
})
export class WidgetCronogramaComponent implements OnInit {

  url;
  theme = 'light';
  user;
  iframeData;
  constructor(
    private storage: Storage,
    private toastController: ToastController,
    public modalController: ModalController
  ) { }

  async ngOnInit() {
    this.user = await this.storage.get('user');
    this.getData();
  }

  getData() {
    this.getUrl();
    this.getIframe();
    this.createIframe();
  }

  getIframe() {
    this.iframeData = `<iframe src=${this.url}"
      style="width:100%;min-height:700px;border:none">
    </iframe>`;
  }

  getUrl() {
    this.url = `https://territory.oden.mx/widget/cronograma/${this.user.id_gimnasio}?theme=${this.theme}`
  }

  changeTheme() {
    this.theme == 'dark' ? this.theme = 'ligh' : this.theme = 'dark';
    this.getData();
  }

  async copyIframe() {
    try {
      await navigator.clipboard.writeText(this.iframeData);
      const toast = await this.toastController.create({
        message: 'Codigo copiado!',
        duration: 2000,
      });
      toast.present();
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  async copyUrl() {
    try {
      await navigator.clipboard.writeText(this.url);
      const toast = await this.toastController.create({
        message: '¡Url copiada!',
        duration: 2000,
      });
      toast.present();
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }

  createIframe() {
    const ifrm = document.createElement("iframe");

    ifrm.setAttribute("src", this.url);
    ifrm.style.width = "100%";
    ifrm.style.height = "400px";
    ifrm.style.border = "none";

    document.getElementById("iframe-container").replaceChildren(ifrm);
  }
}
